<script lang="ts">
    import type { Snippet } from 'svelte';
    import type { Page } from '@shared/types/Tilelist.ts';

    type Props = { page: Page; children: Snippet };

    const { children, page }: Props = $props();

    const pageDataJson = $derived(JSON.stringify(page));
</script>

<!-- NOTE: Do not remove data-origin it is needed for the toggle in Everglades  -->
<div
    id="reptile-search-result"
    class="reptile-search-result"
    data-page={pageDataJson}
    data-qa="reptile-search-result"
    data-origin="dundee"
>
    {@render children()}
</div>

<style lang="scss">
    .reptile-search-result {
        flex: 1 1 100%;
        max-width: 100%;
    }
</style>
